import React, { useState, useEffect } from 'react';
import styles from '../app.module.css';

const ServersSection = ({ formData, handleArrayChange, addServer }) => {
  const [tempServer, setTempServer] = useState(null);
  const [editServerIndex, setEditServerIndex] = useState(null);
  const [errors, setErrors] = useState({});

  const handleSaveServer = () => {
    if (tempServer) {
      const urlPattern = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
      const newErrors = {};

      if (!tempServer.url) {
        newErrors.url = 'URL is required.';
      } else if (!urlPattern.test(tempServer.url)) {
        newErrors.url = 'Invalid URL format. Ensure it starts with http:// or https:// and has a valid domain.';
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }

      handleArrayChange('servers', -1, null, [...formData.servers, tempServer]);

      setTempServer(null);
      setErrors({});
    }

    if (editServerIndex !== null) {
      const server = formData.servers[editServerIndex];
      const urlPattern = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
      const newErrors = {};

      if (!server.url) {
        newErrors.url = 'URL is required.';
      } else if (!urlPattern.test(server.url)) {
        newErrors.url = 'Invalid URL format. Ensure it starts with http:// or https:// and has a valid domain.';
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors({ [editServerIndex]: newErrors });
        return;
      }

      const updatedServers = [...formData.servers];
      updatedServers[editServerIndex] = { ...server };
      handleArrayChange('servers', -1, null, updatedServers);

      setEditServerIndex(null);
      setErrors({});
    }
  };

  const handleRemoveServer = (index) => {
    const updatedServers = formData.servers.filter((_, i) => i !== index);
    handleArrayChange('servers', -1, null, updatedServers);
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[index];
      return newErrors;
    });
  };

  const handleAddServerClick = () => {
    setTempServer({ url: '', description: '' });
  };

  const handleEditServerClick = (index) => {
    setEditServerIndex(index);
  };

  const handleCancel = () => {
    setTempServer(null);
    setEditServerIndex(null);
    setErrors({});
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (tempServer) {
        setTempServer(null);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [tempServer]);

  return (
    <div>
      <h3 className={styles.centeredHeading}>Servers</h3>

      {formData.servers.map((server, index) => (
        editServerIndex === index ? (
          <div key={index} className={styles.mainContainer}>
            <div>
              <label>
                URL <span className={styles.requiredField}>*</span>
              </label>
              <input
                type="text"
                value={server.url}
                onChange={(e) => handleArrayChange('servers', index, 'url', e.target.value)}
                placeholder="Enter URL"
                className={styles.textBox}
              />
              {errors[index]?.url && <p className={styles.inlineAlerts}>{errors[index].url}</p>}
            </div>
            <div>
              <label>Description:</label>
              <input
                type="text"
                value={server.description}
                onChange={(e) => handleArrayChange('servers', index, 'description', e.target.value)}
                placeholder="Enter Description"
                className={styles.textBox}
              />
            </div>
            <div className={styles.sNcButtonContainer}>
              <button className={styles.saveButton} onClick={handleSaveServer}>Save</button>
              <button className={styles.cancelButton} onClick={handleCancel}>Cancel</button>
            </div>
          </div>
        ) : (
          
          <div key={index} className={styles.mainContainer}>
            <p><strong>URL:</strong> {server.url}</p>
            <p><strong>Description:</strong> {server.description}</p>
            <div className={styles.actionButtonsContainer}>
              <button className={styles.editButton} onClick={() => handleEditServerClick(index)}>Edit</button>
              <button className={styles.deleteButton} onClick={() => handleRemoveServer(index)}>Delete</button>
            </div>
          </div>
        )
      ))}

      {editServerIndex === null && tempServer && (
        <div className={styles.mainContainer}>
          <div>
            <label>
              URL <span className={styles.requiredField}>*</span>
            </label>
            <input
              type="text"
              value={tempServer.url}
              onChange={(e) => setTempServer({ ...tempServer, url: e.target.value })}
              placeholder="Enter URL"
              className={styles.textBox}
            />
            {errors.url && <p className={styles.inlineAlerts}>{errors.url}</p>}
          </div>
          <div>
            <label>Description:</label>
            <input
              type="text"
              value={tempServer.description}
              onChange={(e) => setTempServer({ ...tempServer, description: e.target.value })}
              placeholder="Enter Description"
              className={styles.textBox}
            />
          </div>
          <div className={styles.sNcButtonContainer}>
            <button className={styles.saveButton} onClick={handleSaveServer}>Save</button>
            <button className={styles.cancelButton} onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      )}

      {editServerIndex === null && !tempServer && (
        <button className={styles.addNewButton} onClick={handleAddServerClick}>+ Add Server</button>
      )}
    </div>
  );
};

export default ServersSection;
